import { Field } from '@payaca/ambrosia';
import { ComponentProps, FC } from 'react';

import SupplierSelectionControl from './SupplierSelectionControl';

type Props = ComponentProps<typeof SupplierSelectionControl>;

/**
 * The Purchase Order flows' supplier picker: a SupplierSelectionControl under
 * the standard "Supplier you wish to order from" label. Props pass straight
 * through to the control, so callers choose whether it's editable.
 */
const SupplierSelectionField: FC<Props> = (props) => (
  <Field.Legacy className="mb-2.5" name="supplier">
    <Field.Label>Supplier you wish to order from</Field.Label>
    <SupplierSelectionControl {...props} />
  </Field.Legacy>
);

export default SupplierSelectionField;
